<template>
  <transition name="fade">
    <div class="container-fluid" id="register">
      <script type="application/ld+json">
        {
          "@context": "http://schema.org",
          "@graph": [
            {
              "@type": "Article",
              "url": "https://www.teddi.co/assurance/",
              "headline": "Assurance habitation ← Teddi",
              "description": "Découvrez la meilleure assurance habitation, simple et transparente, qui protège votre foyer et déjà ceux de plus 30.000 français.",
              "datePublished": "2020-06-14T17:47:50.000Z",
              "dateModified": "2020-06-15T09:20:51.000Z",
              "mainEntityOfPage": {
                "@type": "WebPage",
                "@id": "https://www.teddi.co/assurance/"
              },
              "publisher": {
                "@type": "Organization",
                "@id": "https://www.teddi.co/",
                "name": "Teddi",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://www.teddi.co/assets/socials/fb-profile.png",
                  "width": 1000,
                  "height": 1000
                }
              },
              "author": {
                "@type": "Person",
                "name": "Thomas"
              }
            }
          ]
        }
      </script>
      <b-row class="pt-md-4 vh-100">
        <b-col md="5" offset-md="2" class="px-md-4">
          <div class="d-flex align-items-center py-3">
            <b-img
              v-if="isFormPropertyView"
              class="icon-md mr-2"
              alt="umbrella-raining"
              :src="require('@/assets/icons/umbrella-raining.png')"
            >
            </b-img>
            <!-- BACK -->
            <b-img
              v-if="isFormUserView"
              @click="
                isFormUserView = false;
                isFormPropertyView = true;
              "
              class="icon-md mr-2 cursor-pointer"
              alt="back-hands"
              :src="require('@/assets/icons/back-hands.svg')"
            >
            </b-img>
            <!-- BACK -->
            <h1>Le logement à assurer</h1>
          </div>

          <b-form class="text-left" @submit.prevent>
            <!-- FIRST STEP VIEW -->
            <div v-show="isFormPropertyView">
              <div class="d-flex align-items-center">
                <h5 class="mb-0 mr-3">J'aimerais assurer</h5>
                <PropertyType />
              </div>

              <transition name="fade">
                <div class="d-md-flex align-items-center" v-if="isPropertyTypeSet">
                  <h5 class="mb-0 mr-3">dont l'adresse est</h5>
                  <PropertyAddress />
                </div>
              </transition>
              <transition name="fade">
                <div
                  class="d-flex align-items-center"
                  v-if="isPropertyAddressSet && isPropertyTypeSet"
                >
                  <h5 class="mb-0 mr-3">la surface habitable est</h5>
                  <SurfaceMin />
                </div>
              </transition>
              <transition name="fade">
                <div
                  class="d-flex align-items-center"
                  v-if="
                    isPropertyAddressSet &&
                      propertyTypes == 0 &&
                      isSurfaceMinSet &&
                      surfaceMin > 4 &&
                      surfaceMin < 251
                  "
                >
                  <h5 class="mb-0 mr-3">situé</h5>
                  <Floor />
                </div>
              </transition>
              <transition name="fade">
                <div
                  class="d-flex align-items-center"
                  v-if="
                    isPropertyAddressSet &&
                      isSurfaceMinSet &&
                      ((isFloorSet && propertyTypes == 0) ||
                        (surfaceMin > 39 && propertyTypes == 1))
                  "
                >
                  <h5 class="mb-0">et comprenant</h5>
                  <Room />
                  <h5 v-if="this.$store.state.optionalFields.room > 1" class="mb-0">pièces</h5>
                  <h5 v-else class="mb-0">pièce</h5>
                </div>
              </transition>
            </div>
            <!-- SECOND STEP VIEW -->
            <transition name="fade">
              <div v-if="isFormUserView">
                <div
                  class="mt-3 d-flex align-items-center"
                  v-if="isPropertyAddressSet && isPropertyTypeSet && isSurfaceMinSet && isRoomSet"
                >
                  <h5 class="mb-0">Je suis</h5>
                  <OccupantType />
                </div>
                <transition name="fade">
                  <div
                    class="mt-3 d-md-flex align-items-center"
                    v-if="
                      isPropertyAddressSet &&
                        isPropertyTypeSet &&
                        isSurfaceMinSet &&
                        isRoomSet &&
                        isOccupantTypeSet &&
                        this.$store.state.optionalFields.occupantType == 'propriétaire'
                    "
                  >
                    <h5 class="mb-0 mr-3">et j'aimerais assurer</h5>
                    <PropertyGoal />
                  </div>
                </transition>
                <transition name="fade">
                  <div
                    class="mt-3 d-md-flex align-items-center"
                    v-if="
                      isPropertyAddressSet &&
                        isPropertyTypeSet &&
                        isSurfaceMinSet &&
                        isRoomSet &&
                        isOccupantTypeSet &&
                        this.$store.state.optionalFields.occupantType == 'propriétaire' &&
                        this.$store.state.optionalFields.propertyGoal ==
                          'mon investissement locatif'
                    "
                  >
                    <h5 class="mb-0 mr-3">Mon adresse personnelle est</h5>
                    <UserAddress />
                  </div>
                </transition>
                <transition name="fade">
                  <div
                    class="mt-3 d-md-flex align-items-center"
                    v-if="
                      isPropertyAddressSet &&
                        isPropertyTypeSet &&
                        isSurfaceMinSet &&
                        isRoomSet &&
                        isOccupantTypeSet &&
                        isUserAddressSet
                    "
                  >
                    <h5 class="mb-0 mr-3">mon prénom est</h5>
                    <FirstName />
                  </div>
                </transition>
                <transition name="fade">
                  <div
                    class="mt-3 d-md-flex align-items-center"
                    v-if="
                      isPropertyAddressSet &&
                        isPropertyTypeSet &&
                        isSurfaceMinSet &&
                        isRoomSet &&
                        isOccupantTypeSet &&
                        isFirstNameSet
                    "
                  >
                    <h5 class="mb-0 mr-3">mon nom est</h5>
                    <LastName />
                  </div>
                </transition>
                <transition name="fade">
                  <div
                    class="mt-3 d-md-flex align-items-center"
                    v-if="
                      isPropertyAddressSet &&
                        isPropertyTypeSet &&
                        isSurfaceMinSet &&
                        isRoomSet &&
                        isOccupantTypeSet &&
                        isFirstNameSet &&
                        isLastNameSet
                    "
                  >
                    <h5 class="mb-md-0 mr-md-3">
                      mon adresse email est
                    </h5>
                    <Email />
                  </div>
                </transition>
              </div>
            </transition>
          </b-form>
        </b-col>
        <b-col md="3" class="d-none d-md-block">
          <div class="d-flex align-items-center justify-content-center py-3">
            <b-img
              class="icon-md mr-2"
              alt="firefighter"
              :src="require('@/assets/icons/firefighter.png')"
            >
            </b-img>
          </div>
          <FormHelper class="pb-5" />
        </b-col>
      </b-row>
      <!-- NEXT -->
        <div
          @click="
            isFormUserView = true;
            isFormPropertyView = false;
          "
          class="cursor-pointer d-flex justify-content-center fixed-bottom py-2 py-md-1 bg-blue"
          v-if="
            isPropertyAddressSet &&
              isPropertyTypeSet &&
              isSurfaceMinSet &&
              isRoomSet &&
              isFormPropertyView
          "
        >
          <IconNext class="icon white slide-right" />
        </div>
      <!-- SUBMIT -->
        <vue-recaptcha
          :loadRecaptchaScript="true"
          ref="invisibleRecaptcha"
          size="invisible"
          sitekey="6LfTAv0UAAAAAIqxP0ib1Y-RAbI4FLpah7Vf39VS"
          @verify="onCaptchaVerified"
          @expired="onCaptchaExpired"
        >
          <div
            @click="recaptcha()"
            class="fixed-bottom py-2 py-md-1 bg-blue submit"
            v-if="
              isPropertyAddressSet &&
                isSurfaceMinSet &&
                isFirstNameSet &&
                isLastNameSet &&
                isEmailSet &&
                isFormUserView
            "
          >
            <IconSubmit class="icon white" />
          </div>
        </vue-recaptcha>

    </div>
  </transition>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Vue from "vue";
import VueRecaptcha from "vue-recaptcha";
import PropertyType from "@/components/content/PropertyType.vue";
import OccupantType from "@/components/content/OccupantType.vue";
import PropertyAddress from "@/components/content/PropertyAddress.vue";
import Room from "@/components/content/Room.vue";
import UserAddress from "@/components/content/UserAddress.vue";
import PropertyGoal from "@/components/content/PropertyGoal.vue";
import SurfaceMin from "@/components/content/SurfaceMin.vue";
import FirstName from "@/components/content/FirstName.vue";
import LastName from "@/components/content/LastName.vue";
import Email from "@/components/content/Email.vue";
import Floor from "@/components/content/Floor.vue";
import IconSubmit from "@/components/icons/IconSubmit.vue";
import IconNext from "@/components/icons/IconNext.vue";
import IconBack from "@/components/icons/IconBack.vue";
import FormHelper from "@/components/content/FormHelper.vue";

export default {
  components: {
    PropertyAddress,
    PropertyGoal,
    UserAddress,
    PropertyType,
    Room,
    SurfaceMin,
    Email,
    Floor,
    IconSubmit,
    FormHelper,
    VueRecaptcha,
    OccupantType,
    FirstName,
    LastName,
    IconNext,
    IconBack,
  },
  metaInfo: {
    title: "La meilleure assurance habitation",
    titleTemplate: "%s ← Teddi",
    meta: [
      { "http-equiv": "Content-Type", content: "text/html; charset=utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content:
          "Découvrez la meilleure assurance habitation, simple et transparente, qui protège votre foyer et déjà ceux de plus 30.000 français.",
      },
      {
        property: "og:title",
        content: "Création de votre recherche ← Teddi",
      },
      { property: "og:site_name", content: "Teddi" },
      { property: "og:type", content: "website" },
      {
        property: "og:url",
        content: "https://www.teddi.co/assurance",
      },
      {
        property: "og:image",
        content: "https://www.teddi.co/assets/socials/fb-cover.jpg",
      },
      {
        property: "og:description",
        content:
          "Découvrez la meilleure assurance habitation, simple et transparente, qui protège votre foyer et déjà ceux de plus 30.000 français.",
      },
    ],
    link: [{ rel: "canonical", href: "https://www.teddi.co/assurance" }],
  },
  data() {
    return {
      isRecaptchaValid: false,
      isFormPropertyView: true,
      isFormUserView: false,
    };
  },
  computed: {
    ...mapState({
      surfaceMin: state => state.userSearch.surfaceMin,
      propertyTypes: state => state.userSearch.propertyTypes,
    }),
    ...mapGetters([
      "isPropertyTypeSet",
      "isPropertyAddressSet",
      "isSurfaceMinSet",
      "isEmailSet",
      "isFirstNameSet",
      "isLastNameSet",
      "isFloorSet",
      "isRoomSet",
      "isOccupantTypeSet",
      "isUserAddressSet",
    ]),
  },

  methods: {
    recaptcha() {
      /* this.$refs.invisibleRecaptcha.execute(); */
      this.$store.dispatch("sendToPartnerInsurance");
    },
    onCaptchaExpired() {
      this.$refs.invisibleRecaptcha.reset();
    },
    async onCaptchaVerified(token) {
      this.$refs.invisibleRecaptcha.reset();
      await this.$store.dispatch("sendToPartnerInsurance");
    },
  },
  mounted() {
    this.$store.commit("SET_PROPERTY_TYPE", [0]);
  },
  watch: {
    propertyTypes: {
      handler() {
        if (this.propertyTypes.length > 1)
          Vue.notify({
            group: "global",
            title: "Vous ne pouvez sélectionner qu'un seul type de bien",
          });
      },
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
h1 {
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 0;
}
form {
  div.d-flex,
  div.d-md-flex {
    margin-bottom: 1rem;
  }
  padding-bottom: 8rem;
}
</style>
